import { useLocation } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { can, locate, useMyRights } from "../../lib/rights";

// Blocks pages / sub-tabs an associate or employee has no "view" right for.
export const RightsGuard = ({ children }) => {
  const { user } = useAuth();
  const rights = useMyRights(user);
  const { pathname } = useLocation();
  if (!rights) return children;
  const loc = locate(pathname);
  if (loc && !can(rights, loc.tab.key, "view", loc.sub)) {
    return (
      <div className="mx-auto mt-24 max-w-md rounded-lg border bg-white p-8 text-center" data-testid="rights-no-access">
        <ShieldOff className="mx-auto mb-3 h-8 w-8 text-gray-400" />
        <p className="font-semibold text-gray-800">You don't have access to this section</p>
        <p className="mt-1 text-sm text-gray-500">Please contact your administrator.</p>
      </div>
    );
  }
  const hidden = loc ? Object.entries(rights[loc.tab.key]?.subs || {}).filter(([, v]) => v === false).map(([k]) => k) : [];
  return (
    <>
      {hidden.length > 0 && <style>{hidden.map((k) => `[role="tab"][id$="-trigger-${k}"]`).join(",") + "{display:none!important}"}</style>}
      {children}
    </>
  );
};
